function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.c{fill:none;}.a{stroke:#989898;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-width:2px;}.b{fill:#989898;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(1 1)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M25.385,14.056V0H0V14.056",
  transform: "translate(3.808)"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M33,5.111H0L2.538,0H30.462Z",
  transform: "translate(0 17.889)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(8.967 1.725)"
}, /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M11.959,2H3.107a1.085,1.085,0,0,0-1.1,1.066L2,12.66l2.213-2.132h7.746a1.09,1.09,0,0,0,1.107-1.066v-6.4A1.09,1.09,0,0,0,11.959,2ZM8.086,6.8H6.98V3.6H8.086Zm0,2.132H6.98V7.863H8.086Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "c",
  d: "M0,0H15.066V14.66H0Z"
})));

function SvgIconTrazabilidad(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 25,
    viewBox: "0 0 35 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrazabilidad);
export default __webpack_public_path__ + "static/media/icon-trazabilidad.124de002.svg";
export { ForwardRef as ReactComponent };